import { AssetDto } from '@/shared/lib/sj-orm/models/assets/asset.dto';

import { AssetCategory } from './types';

export const isAssetCategory = (category: string): category is AssetCategory =>
  Object.values(AssetCategory).includes(category as AssetCategory);

export const NAME_KEY_BY_ASSET_CATEGORY: Record<AssetCategory, keyof AssetDto> = {
  [AssetCategory.DEBIT_ACCOUNTS]: 'nickName',
  [AssetCategory.RESIDENTIAL_REAL_ESTATE]: 'nickName',
  [AssetCategory.COMMERCIAL_REAL_ESTATE]: 'nickName',
  [AssetCategory.LAND]: 'nickName',
  [AssetCategory.LEGAL_ENTITIES]: 'nickname',
  [AssetCategory.JEWELLERY]: 'nickName',
  [AssetCategory.BANK_CELLS]: 'nickname',
  [AssetCategory.METAL_ACCOUNTS]: 'nickname',
  [AssetCategory.CENTRALIZED_WALLET]: 'nickname',
  [AssetCategory.DECENTRALIZED_WALLET]: 'nickname',
  [AssetCategory.PRECIOUS_STONES]: 'nickName',
  [AssetCategory.COMMODITY_ASSET_TOKENS]: 'nickname',
  [AssetCategory.BROKERAGE_ACCOUNT]: 'nickName',
  [AssetCategory.SECURITIES_AND_STOCKS]: 'nickname',
  [AssetCategory.BONDS]: 'nickname',
  [AssetCategory.EXCHANGE_OPTIONS]: 'nickName',
  [AssetCategory.OVER_THE_COUNTER_OPTIONS]: 'nickName',
  [AssetCategory.FORWARDS]: 'nickName',
  [AssetCategory.FUTURES]: 'nickName',
  [AssetCategory.MY_FUND]: 'nickName',
  [AssetCategory.PUBLIC_FUND]: 'nickname',
};
